module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n.form-control{\r\n    width:40px;\r\n    padding: 3px;\r\n    font-size: 11px;\r\n    text-align: center;\r\n}\r\ntd{\r\n    font-size: 12px;\r\n    text-align: center;\r\n    padding:0.5em;\r\n}\r\n.list li{\r\n    display: inline-block;\r\n    font-size: 11px;    \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/time-roll-generation/time-roll-gen-form/time-roll-gen-form.component.css
// module id = ./src/app/hrms/Attendance-Leaves/time-roll-generation/time-roll-gen-form/time-roll-gen-form.component.css
// module chunks = main